import { Component } from '@angular/core';

import { NceService } from '../services/nce.service';

import { StorageService } from '../../shared/services/storage.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'nce-declaration',
    templateUrl: 'declaration.component.html'
})
export class NceDeclarationComponent{

    isExtensionNCE: string;

    constructor(
        private _nceService: NceService,
        private _layoutService: LayoutService,
        private _storageService: StorageService,
        private _pageNavigationService: PageNavigationService
    ) {
        
    }

    ngOnInit() {
        this._layoutService.setCurrentPage('nce-declaration');
        this._nceService.resetNCEData();
        this._nceService.resetDeclaration();
        this.isExtensionNCE = this._storageService.getSessionItem('extensionNCE');
    }

    isDisableSubmit(){
        return this._nceService.isDisableSubmitDeclaration();
    }

    getDeclarationData(){
        return this._nceService.getDeclaration();
    }

    submitDeclaration(){
        this._nceService.saveDeclaration();
    }
    
    getRequestID(){
        return this._nceService.vNCEData.nce_request_id || this._nceService.vDetailNCE.nce_request_id || this._nceService.vNCEID.nce_request_id;
    }

    goBack(){
        let vLink = ['nce-application/upload-attachment'];
        this._pageNavigationService.navigate(vLink);
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/declaration.component.ts